import React from 'react';

import { AppProvider } from './providers';

const App = () => (
  <AppProvider />
);

export default App;
